import type React from 'react';

import { TruncatedText } from '@vlabs/shared/components/truncated-text/TruncatedText';
import { useWindowSize } from '@vlabs/uikit';
import cn from 'classnames';

import st from './shared.module.sass';

interface TagsRowProps {
  tags: string[];
}

function TagsRow({ tags }: TagsRowProps): React.JSX.Element {
  const { width } = useWindowSize();
  return (
    <div
      className={cn(st.RowValue, {
        [st.RowValue_small]: width && width < 1920,
        [st.RowValue_large]: width && width >= 1920,
      })}
    >
      <TruncatedText
        hasTruncation
        tooltipContent={tags.join(', ')}
      >
        {tags.join(', ')}
      </TruncatedText>
    </div>
  );
}

export { TagsRow };
